var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBihance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.32 267.878h-46.3v50.687h46.3a25.344 25.344 0 1 0 0-50.687ZM212.622 212.989a23.924 23.924 0 0 0-23.922-23.925l-.1-.055-.022.055h-43.555v47.85H188.7a23.925 23.925 0 0 0 23.922-23.925ZM334.578 240.281a30.557 30.557 0 0 0-30.339 26.928h60.679a30.557 30.557 0 0 0-30.34-26.928Z",
    fill: "#ffffff",
    className: "fill-000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0Zm-52.656 349.528h-94.8V158.1h91.9a48.7 48.7 0 0 1 22.265 92.007 51.6 51.6 0 0 1-19.368 99.42Zm84.3-180.255h92.87v22.8h-92.87Zm113.342 122.864h-96.444q-.022.612-.023 1.229a31.517 31.517 0 0 0 58.73 15.9l.064.037h36.85c-9.006 30.666-35.887 44.447-65.2 44.447-38.812 0-67.687-32.007-67.687-71.489s28.875-71.489 67.687-71.489 72.913 33.333 66.023 81.365Z",
    fill: "#ffffff",
    className: "fill-000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBihance);
export default __webpack_public_path__ + "static/media/bihance.5d9e97c0c816486c2ef29a02179f7100.svg";
export { ForwardRef as ReactComponent };